import { useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FaMapMarkerAlt, FaPhone, FaEnvelope, FaFacebookF, FaTwitter, FaLinkedinIn, FaPaperPlane } from "react-icons/fa";

const initialState = {
  name: "",
  email: "",
  message: ""
};

export const Contact = (props) => {
  const [formData, setFormData] = useState(initialState);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({ ...prevState, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      // IMPORTANT: Move these credentials to environment variables
      const serviceId = process.env.REACT_APP_EMAILJS_SERVICE_ID;
      const templateId = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
      const userId = process.env.REACT_APP_EMAILJS_USER_ID;

      // Importing emailjs dynamically for better performance
      const emailjs = await import("emailjs-com");

      await emailjs.send(
        serviceId,
        templateId,
        formData,
        userId
      );

      setFormData(initialState);
      toast.success("Message sent successfully!");
    } catch (error) {
      console.error("Error sending message:", error);
      toast.error("Failed to send message. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div>
      <div id="contact">
        <div className="container">
          <div className="section-title text-center">
            <h2>Get In Touch</h2>
            <p className="subtitle">
              We'd love to hear from you! Fill out the form below and we'll get back to you as soon as possible.
            </p>
          </div>

          <div className="contact-wrapper">
            <div className="contact-form-container">
              <form onSubmit={handleSubmit}>
                <div className="form-row">
                  <div className="form-group-landing">
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={formData.name}
                      className="form-control-landing"
                      placeholder="Your Name"
                      required
                      onChange={handleChange}
                    />
                    <label htmlFor="name" className="floating-label">Name</label>
                  </div>

                  <div className="form-group-landing">
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      className="form-control-landing"
                      placeholder="Your Email"
                      required
                      onChange={handleChange}
                    />
                    <label htmlFor="email" className="floating-label">Email</label>
                  </div>
                </div>

                <div className="form-group-landing">
                  <textarea
                    name="message"
                    id="message"
                    value={formData.message}
                    className="form-control-landing"
                    rows="4"
                    placeholder="Your Message"
                    required
                    onChange={handleChange}
                  ></textarea>
                  <label htmlFor="message" className="floating-label">Message</label>
                </div>

                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="btn btn-custom"
                >
                  {isSubmitting ? (
                    <span className="btn-text">Sending...</span>
                  ) : (
                    <>
                      <span className="btn-text">Send Message</span>
                      <FaPaperPlane className="btn-icon" />
                    </>
                  )}
                </button>
              </form>
            </div>

            <div className="contact-info-container">
              <div className="info-card">
                <h3>Contact Information</h3>

                <div className="contact-item">
                  <div className="icon-wrapper">
                    <FaMapMarkerAlt className="contact-icon" />
                  </div>
                  <div className="contact-text">
                    <span>Address</span>
                    <p>{props.data ? props.data.address : "Loading..."}</p>
                  </div>
                </div>

                <div className="contact-item">
                  <div className="icon-wrapper">
                    <FaPhone className="contact-icon" />
                  </div>
                  <div className="contact-text">
                    <span>Phone</span>
                    {[
                      props.data && props.data.phone,
                      props.data && props.data.phone2,
                    ].map((phone, index) => (
                      phone && <p key={index}>{phone}</p>
                    ))}
                  </div>
                </div>

                <div className="contact-item">
                  <div className="icon-wrapper">
                    <FaEnvelope className="contact-icon" />
                  </div>
                  <div className="contact-text">
                    <span>Email</span>
                    <p>{props.data ? props.data.email : "Loading..."}</p>
                  </div>
                </div>

                <div className="social">
                  <h4>Follow Us</h4>
                  <ul>
                    <li>
                      <a href={props.data ? props.data.facebook : "/"} aria-label="Facebook">
                        <FaFacebookF className="social-icon" />
                      </a>
                    </li>
                    <li>
                      <a href={props.data ? props.data.twitter : "/"} aria-label="Twitter">
                        <FaTwitter className="social-icon" />
                      </a>
                    </li>
                    <li>
                      <a href={props.data ? props.data.youtube : "/"} aria-label="LinkedIn">
                        <FaLinkedinIn className="social-icon" />
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div id="footer">
        <div className="container text-center">
          <p>
            &copy; 2021 - {new Date().getFullYear()} Lion Multipurpose Cooperative Society. Experience supported by{" "}
            <a href="https://obedokpala.netlify.app" rel="nofollow">
              Meetbeddy
            </a>
          </p>
        </div>
      </div>

      <ToastContainer
        position="bottom-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
};